module.exports = __webpack_public_path__ + "static/media/actualites.a2a01f1a.jpg";